export default __webpack_public_path__ + "static/media/NonVegTiffin.470a5e85.png";